export default __webpack_public_path__ + "media/zurb/img/experience-design/stat-table2-a2055f63136a4cbb17df6f88a0421975.png";